
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/material-ui/api/text-field",
      function () {
        return require("private-next-pages/material-ui/api/text-field.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/material-ui/api/text-field"])
      });
    }
  